import React from 'react'
import PropTypes from 'prop-types'
import { localsMessages } from '../utility/getTemplateData'

const messages = localsMessages('common/subHeader');
const STYLES = {
	fontFamilyMedium: {
		fontFamily: 'pp-sans-big-medium',
	},
	fontFamilyRegular: {
		fontFamily: 'pp-sans-big-regular',
	},
	textSize15: {
		fontSize: 15,
	},
	noMargin: {
		margin: '0px auto',
	},
	headerPurpose: {
		marginBottom: 0,
		lineHeight: 1.3,
	},
	headerDonationId: {
		margin: 0,
		lineHeight: 1.3,
	}
}

class SubHeader extends React.Component {
	constructor() {
		super();
		const { label: { donateto = '', purpose: purposeLabel = '' } = {} } = messages || {};
		this.state = { donateto, purposeLabel, };
	}

	formatOrgName() {
		let { label, orgName } = this.props;
		label = label && label.toString().replace(/\s/g, '').toUpperCase();
		let OName = orgName && orgName.toString().replace(/\s/g, '').toUpperCase();
		return label.includes(OName) ? '' : orgName;
	}

	render() {
		let { donateto = '', purposeLabel = '' } = this.state;
		let donationName = this.props.label;
		let orgName = this.formatOrgName();
		let donationId = this.props.donationId;
		let { formatedDonationName, formatedOrgName, formatedDonationId } = {};

		if (donationName === orgName) {
			formatedDonationName = donationName;
			formatedOrgName = '';
		} else {
			formatedDonationName = donationName
		}

		if (orgName && !donationId) {
			if (donationName !== orgName) {
				formatedOrgName = `${purposeLabel} ${orgName}`;
			}
		}

		if (!orgName && donationId) {
			formatedDonationId = `${purposeLabel} ${donationId}`;
		}

		if (orgName && donationId) {
			if (donationName !== orgName) {
				formatedOrgName = `${purposeLabel} ${orgName}`;
				formatedDonationId = donationId;
			} else {
				formatedOrgName = '';
				formatedDonationId = `${purposeLabel} ${donationId}`;
			}
		}

		return (
			<div className="col-xs-12 col-sm-12 col-md-12 donate_sub_header">
				<h4
					className="text-center"
					style={{ ...STYLES.fontFamilyMedium, ...STYLES.textSize15, ...STYLES.noMargin }}
					id="headerDonateTo">
					{donateto}
				</h4>
				<h4
					className="text-center"
					style={{ ...STYLES.fontFamilyMedium, ...STYLES.textSize15, ...STYLES.noMargin }}
					id="headerDonateToName">
					{formatedDonationName}
				</h4>

				{formatedOrgName && <h5 className="text-center"
					style={{ ...STYLES.fontFamilyRegular, ...STYLES.textSize15, ...STYLES.headerPurpose }}>
					{formatedOrgName}
					</h5>
				}
				{formatedDonationId && <h5 className="text-center"
					style={{ ...STYLES.fontFamilyRegular, ...STYLES.textSize15, ...STYLES.headerDonationId }}>
					{formatedDonationId}
					</h5>
				}
			</div>
		);
	}
}

SubHeader.propTypes = {
	label: PropTypes.string.isRequired,
	orgName: PropTypes.string.isRequired,
	donationId: PropTypes.string
};

export default SubHeader



// WEBPACK FOOTER //
// ./components/subHeader.js